var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',_vm._g(_vm._b({staticClass:"date-picker-start-end",attrs:{"type":"daterange","start-placeholder":"Start date","end-placeholder":"End date","range-separator":"To"},model:{value:(_vm.internalRange),callback:function ($$v) {_vm.internalRange=$$v},expression:"internalRange"}},'el-date-picker',_vm.$attrs,false),_vm.mergedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }